import { Box } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player/lazy";
import { JobDisplays, VideoOrientation } from "../../constants";

const JobFeatureVid = ({ vidUrl, vidSize, shadow = false }) => {
  const isPortrait = vidSize === VideoOrientation.portrait;
  return (
    <Box sx={{ py: 1 }}>
      <Box
        sx={{
          width: "100%",
          borderRadius: JobDisplays.borderRadius,
          backgroundColor: JobDisplays.backgroundColor,
          boxShadow: shadow ? JobDisplays.boxShadowStrong : "none",
        }}>
        <div
          style={{
            width: "100%",
            // paddingTop: isPortrait ? "178.98%" : "56.25%",
            paddingTop: isPortrait ? "177.8%" : "56.25%",
            borderRadius: JobDisplays.borderRadius,
            overflow: "hidden",
            position: "relative",
            // ...(shadow && {
            //   boxShadow: JobDisplays.boxShadow,
            // }),
          }}>
          <ReactPlayer
            url={vidUrl}
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
            controls
          />
        </div>
      </Box>
    </Box>
  );
};

export default JobFeatureVid;
